define('rebrush/components/layout/search',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'rebrush/system/animation'
], function(
	$,
	_,
	Component,
	BEM,
	Animation
) {
	var endPrecedingAnimation = $.noop;

	return Component.create({
		$init: function() {
			this.docRoot = $('html');
			this.cube = BEM.block('header').getElements('cube');
			this.bindEvents();
		},

		bindEvents: function() {
			$(document.body).on('click', '.' + BEM.buildElementClassname('header-functions', 'search-button'), _.bind(function(e) {
				e.preventDefault();
				this.openSearch();
			}, this));

			$(document.body).on('click', '.' + BEM.buildElementClassname('header-search', 'button', 'close'), _.bind(function(e) {
				e.preventDefault();
				this.closeSearch();
			}, this));

			$(document.body).on('click', '.' + BEM.buildElementClassname('header', 'shadow'), _.bind(this.closeSearch, this));
			$(document.body).on('click', '.' + BEM.buildBlockClassname('page-shadow'), _.bind(this.closeSearch, this));

			$(document.body).on('keyup', _.bind(function(e) {
				var isEscape = ('key' in e) ?
					(e.key === 'Escape' || e.key === 'Esc') :
					(e.keyCode === 27);

				if (isEscape) {
					e.preventDefault();
					this.closeSearch();
				}
			}, this));
		},

		openSearch: function() {
			var onAnimationEnd = _.bind(function() {
				endPrecedingAnimation = $.noop;
				this.docRoot.removeClass('search-showing search-hiding');
				this.docRoot.addClass('search-shown');
			}, this);


			if (Animation.supportAnimations) {
				endPrecedingAnimation();
				endPrecedingAnimation = onAnimationEnd;

				this.cube.one(Animation.transitionEndEventName, onAnimationEnd);

				this.docRoot.addClass('search-in');
				this.cube.bemAddModifier('show-top');
				_.defer(_.bind(function() {
					this.docRoot.addClass('search-showing');
				}, this));
				$('.' + BEM.buildElementClassname('header-search', 'input')).focus();
			} else {
				this.cube.bemAddModifier('show-top');
				onAnimationEnd();
			}
		},

		closeSearch: function() {
			var onAnimationEnd = _.bind(function() {
				endPrecedingAnimation = $.noop;
				this.docRoot.removeClass('search-in search-hiding search-shown');
			}, this);

			if (Animation.supportAnimations) {
				endPrecedingAnimation();
				endPrecedingAnimation = onAnimationEnd;

				this.docRoot.removeClass('search-showing search-shown');
				this.docRoot.addClass('search-hiding');
				this.cube.bemRemoveModifier('show-top');
				this.cube.one(Animation.transitionEndEventName, onAnimationEnd);
			} else {
				this.cube.bemRemoveModifier('show-top');
				onAnimationEnd();
			}
		}
	});
});
